export default "/images/vendor/flag-icon-css/flags/1x1/tk.svg?2619557b557f9684e1c058a0bfd014de";